import axios from 'axios'
import config from '../config'

const File = {
    state: {
        error: false,
        msg: '',
        key: '',
        noticeKey: '',
        imagesUrl: '',
        files: {},
        images: {},
        pic: {}
    },
    mutations: {
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg,
        KEY: (state, key) => state.key = key,
        NOTICEKEY: (state, noticeKey) => state.noticeKey = noticeKey,
        IMAGES: (state, images) => state.images = images,
        NOTICEFILES: (state, files) => state.files = files,
        

    },
    actions: {
        async addProductFile({commit}, formData){
            const cfg = {headers: {'Content-Type': 'multipart/form-data'}}
          await  axios.post(config.UPDATE_PRODUCT_FILE, formData, cfg )          
          
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
                commit('KEY', result.data.key)
                
              
            }).catch((err) => {
                console.log(err);
            });
        },
        async addBundleFile({commit}, data){
            const cfg = {headers: {'Content-Type': 'multipart/form-data'}}
            await axios.post(config.UPDATE_BUNDLE_FILE, data, cfg )
            .then(function (response) {
                commit('ERROR', response.data.error)
                commit('MSG', response.data.msg)
                commit('KEY', response.data.key)
            })
            .catch(function (error) {
                console.log(error)
            })
        },
        async addNoticeFile({commit, state}, data){
            const cfg = {headers: {'Content-Type': 'multipart/form-data'}}
            await axios.post(config.UPDATE_NOTICE_FILE, data, cfg )
           .then((result) => {
               console.log(result);
            commit('ERROR', result.data.error)
            commit('MSG', result.data.msg)
            commit('NOTICEKEY', result.data.key)
            console.log(state.noticeKey);
           }).catch((err) => {
               console.log(err);
           });
        },
        async LoadImgFile({commit}, key){
            const response = await axios({
                method:'get',
                url: config.LOAD_FILE + key,
                  responseType: 'blob'
            })
            await commit('IMAGES', response.data)
                     },
                     
        async LoadFile({commit}, key){
            const response = await axios({
                method:'get',
                url: config.LOAD_FILE + key,
                  responseType: 'blob'
            })
            await commit('NOTICEFILES', response.data)
            console.log(response.data);
                     }
                     
    },
    getters: {
        getFileError: state => state.error,
        getFileMsg: state => state.msg,
        getFileKey: state => state.key,
        getNoticeKey: state => state.noticeKey,
        getImageFile: state => state.imageUrl,
        getImages: state => state.images,
        getNoticeFile: state => state.files
    },
 
}

export default File;